import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/signout')({
  beforeLoad: () => {
    throw redirect({ to: '/' });
  }
});
